<template>
  <default>
    <div class="tw-mb-4 c-blue-text">
      <v-chip-group mandatory active-class="primary">
        <v-chip active-class="false" :to="{ name: 'Dashboard' }">Dashboard</v-chip>
        <span class="mt-2 mx-2"> > </span>
        <v-chip active-class="false" :to="{ name: 'Products' }">Products</v-chip>
        <span class="mt-2 mx-2"> > </span>
        <v-chip :to="{ name: 'AkibaPlan' }">{{ $options.name }}</v-chip>
      </v-chip-group>
    </div>

    <!-- Main Card for Akiba Halisi Plan Calculator -->
    <v-card elevation="2" class="main-card tw-px-4 md:tw-px-8 tw-py-6 md:tw-py-8 tw-rounded-lg tw-shadow-lg tw-bg-white">
      <!-- Title Section with Icon -->
      <div class="tw-flex tw-items-center tw-mb-6">
        <img src="/images/icons/top-icon.png" alt="Akiba Halisi Icon" class="tw-w-10 tw-h-10 tw-mr-3" />
        <h2 class="tw-text-2xl tw-font-semibold c-blue-text">Akiba Halisi Plan Calculator</h2>
      </div>

      <!-- Form Container -->
      <div class="form-container tw-w-full tw-flex tw-flex-wrap tw-py-4 md:tw-py-6 tw-bg-gray-50 tw-rounded-md tw-shadow-inner lg:tw-shadow-lg">
        <keep-alive>
          <component
            :is="current"
            :productData="productData"
            :benefits="benefits"
            :terms="terms"
            :quoteSummaryData="quoteSummaryData"
            @to-quote-summary="toQuoteSummary"
          ></component>
        </keep-alive>
      </div>
    </v-card>
  </default>
</template>

<script>
import Default from '../../layouts/Default';
import CardTitle from '../../components/CardTitle';
import BackButton from '../../components/BackButton';
import QuoteSummary from '../../components/rfq/QuoteSummary';
import AkibaClientQuotation from '../../components/rfq/akiba-halisi/Quote';
import ProductMixin from '@/mixins/ProductMixin';
import savedQuoteMixin from '../../mixins/savedQuoteMixin';

export default {
  name: 'AkibaHalisiPlan',
  metaInfo: {
    title: 'RFQ - Akiba Plan',
  },
  components: {
    QuoteSummary,
    BackButton,
    CardTitle,
    Default,
    AkibaClientQuotation,
  },
  mixins: [ProductMixin, savedQuoteMixin],
  data() {
    return {
      current: AkibaClientQuotation,
      productData: { prodCode: 2013102 },
      benefits: [
        { coverName: 'Accidental Death Benefit', coverProdCode: 2013497 },
        { coverName: 'Total & Permanent Disability', coverProdCode: 2013496 },
        { coverName: 'Waiver of Premium', coverProdCode: 2013495 },
        { coverName: 'Medical Reimbursement', coverProdCode: 2013499 },
        { coverName: 'Critical Illness', coverProdCode: 2013498 },
        { coverName: 'Retrenchment', coverProdCode: 2016609 },
      ],
      terms: [
        { years: 6, optionCode: 2016206 },
        { years: 9, optionCode: 2016207 },
        { years: 12, optionCode: 2012141 },
        { years: 15, optionCode: 2012142 },
        { years: 18, optionCode: 2012143 },
      ],
      quoteSummaryData: {},
    };
  },
  mounted() {
    this.checkSavedQuote('akiba');
  },
};
</script>

<style scoped>

.main-card {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 2rem;
}

.form-container {
  background-color: #f9fafb;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.05);
}

.tw-text-2xl {
  font-size: 1.5rem;
  color: #1e3a8a;
}
</style>
